import { Component } from 'react';
import classNames from 'classnames/bind';
import autoBind from 'react-autobind';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';

import withComponentName from '../../../../../decorators/withComponentName';
import PresentationsSvc from '../../../../../services/dbServices/PresentationsSvc';

import FiltersMobileModal from '../FiltersMobileModal';
import FilterInner from './FilterInner';

import Styles from '../styles.module.scss';

const cx = classNames.bind(Styles);

class PeriodsFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openFilterModal: false,
      dropdown: {
        open: false,
        isSelectAll: true,
        title: 'All Periods',
        options: [],
      },
    };
    autoBind(this);
  }

  componentDidMount() {
    this.generateData();
  }

  componentDidUpdate(prevProps) {
    const { isReset } = this.props;
    if (isReset && isReset !== prevProps.isReset) {
      const { dropdown } = this.state;
      const newOptions = dropdown.options.map((obj) => ({
        ...obj, select: true,
      }));
      this.setState({
        dropdown: {
          ...dropdown,
          isSelectAll: true,
          title: 'All Periods',
          options: newOptions,
        },
      });
    }
  }

  callAPI(params) {
    return PresentationsSvc.getPresentationsData(params)
      .then(({ data }) => data || {})
      .catch(() => { });
  }

  async generateData() {
    const { isAllPeriodsSelected, selectedPeriods } = this.props;
    const data = await this.callAPI({
      group: 'period',
      per: 1,
    });
    const periodsKeys = Object.keys(data);
    const newOptions = periodsKeys
      .filter((f) => f)
      .map((obj) => ({
        title: obj,
        value: obj,
        select: isAllPeriodsSelected || selectedPeriods.includes(obj),
      }));
    let dropdownTitle = 'Select Periods';
    if (isAllPeriodsSelected) {
      dropdownTitle = 'All Periods';
    } else {
      const selectedOptions = newOptions.filter((f) => f.select);
      if (selectedOptions.length) {
        dropdownTitle = selectedOptions.map(({ title }) => title).join(', ');
      }
    }
    this.setState({
      dropdown: {
        open: false,
        isSelectAll: isAllPeriodsSelected,
        title: dropdownTitle,
        options: newOptions,
      },
    });
  }

  toggleDropdown(status, event, source) {
    const { width } = this.props;
    const { dropdown } = this.state;

    if (width <= 1024) return this.openFilterModal();

    if (
      status === false
      && source.source === 'select'
    ) {
      return;
    }

    this.setState({
      dropdown: {
        ...dropdown,
        open: status,
      },
    });
  }

  openFilterModal() {
    const { openFilterModal } = this.state;

    this.setState({ openFilterModal: !openFilterModal });
  }

  handleCloseModal() {
    this.setState({ openFilterModal: false });
  }

  handleSelectAll() {
    const { dropdown } = this.state;
    const newOptions = dropdown.options.map((obj) => ({
      ...obj, select: !dropdown.isSelectAll,
    }));
    this.setState({
      dropdown: {
        ...dropdown,
        isSelectAll: !dropdown.isSelectAll,
        title: !dropdown.isSelectAll ? 'All Periods' : 'Select Periods',
        options: newOptions,
      },
    }, () => {
      this.saveDataIntoProps();
    });
  }

  handleOptionSelect(value) {
    const { dropdown } = this.state;
    const { piwikEnabled } = this.props;
    const newOptions = dropdown.options.map((obj) => ({
      ...obj,
      select: obj.value === value ? !obj.select : obj.select,
    }));
    const selectedOptions = newOptions.filter((f) => f.select);
    let dropdownTitle = 'Select Periods';
    let { isSelectAll } = dropdown;
    if (selectedOptions.length === newOptions.length) {
      dropdownTitle = 'All Periods';
      isSelectAll = true;
    } else if (selectedOptions.length) {
      dropdownTitle = selectedOptions.map(({ title }) => title).join(', ');
      isSelectAll = false;
    }
    this.setState({
      dropdown: {
        ...dropdown,
        options: newOptions,
        title: dropdownTitle,
        isSelectAll,
      },
    }, () => {
      this.saveDataIntoProps();
    });
    if (piwikEnabled) {
      _paq.push(['trackEvent', 'IR filters', `period ${value}`]);
    }
  }

  saveDataIntoProps() {
    const { savePropsData } = this.props;
    const { dropdown } = this.state;
    const { isSelectAll, options } = dropdown;
    const selectedOptions = options
      .filter(({ select }) => select)
      .map(({ value }) => value);

    savePropsData({
      isAllPeriodsSelected: isSelectAll,
      selectedPeriods: selectedOptions,
    });
  }

  render() {
    const { width, isIR } = this.props;
    const { dropdown, openFilterModal } = this.state;

    return (
      <Dropdown
        id={cx('investor-periods-filter-dropdown')}
        className={cx('common-seo-filters_btn', { ir: isIR })}
        show={dropdown.open}
        onToggle={this.toggleDropdown}
      >
        <Dropdown.Toggle>
          <div className={Styles.header_btn}>
            <div className={Styles.header_holder}>
              <div className={Styles.main_header}>{dropdown.title}</div>
              <div className={Styles.sub_header}>Period</div>
            </div>
            <div className={Styles.header_icon}>
              <FontAwesomeIcon icon={dropdown.open ? faChevronUp : faChevronDown} />
            </div>
          </div>
        </Dropdown.Toggle>
        {width >= 1025 ? (
          <Dropdown.Menu flip={false}>
            <FilterInner
              options={dropdown.options}
              isSelectAll={dropdown.isSelectAll}
              handleSelectAll={this.handleSelectAll}
              handleOptionSelect={this.handleOptionSelect}
              isIR={isIR}
            />
          </Dropdown.Menu>
        ) : (
          <FiltersMobileModal
            openFilter={openFilterModal}
            handleCloseModal={this.handleCloseModal}
            showCloseIcon
            width={width}
          >
            <FilterInner
              options={dropdown.options}
              isSelectAll={dropdown.isSelectAll}
              handleSelectAll={this.handleSelectAll}
              handleOptionSelect={this.handleOptionSelect}
              isIR={isIR}
            />
          </FiltersMobileModal>
        )}
      </Dropdown>
    );
  }
}

export default withComponentName(PeriodsFilter);
